import { render } from "./supportFaqArticle.vue?vue&type=template&id=1e222702&scoped=true&ts=true"
import script from "./supportFaqArticle.vue?vue&type=script&lang=ts"
export * from "./supportFaqArticle.vue?vue&type=script&lang=ts"

import "./supportFaqArticle.vue?vue&type=style&index=0&id=1e222702&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e222702"]])

export default __exports__